export default "__VITE_ASSET__CM6APitk__"